<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span class="d-flex justify-content-between align-items-center m-3">
        <span class="col-auto d-flex align-items-center gap-3">
          <h2 class="mb-0">Proposal</h2>
          <span class="lds-ring inline me-auto ms-2" *ngIf="showSmallLoader">
            <jni-spinner></jni-spinner>
          </span>
          <div
            class="prospects-panel d-flex justify-content-between ms-2 me-auto">
            <label
              class="ms-2 nav-link p-0 d-flex align-items-center"
              *ngIf="copyButtonStatus"
              (click)="onCopyProposal()">
              Copy
            </label>
            <label class="ms-2 nav-link p-0 d-flex align-items-center">
              <p-radioButton
                [value]="'Open'"
                id="Open"
                type="radio"
                class="me-2"
                name="radio"
                value="Openorder"
                [(ngModel)]="selectedRadioButton"
                (click)="getQuoteOnChange('Open')" />
              <span class="link">Open</span>
            </label>
            <label class="ms-2 nav-link p-0 d-flex align-items-center">
              <p-radioButton
                [value]="'Emailed'"
                id="Emailed"
                type="radio"
                class="me-2"
                name="radio"
                value="Openorder"
                [(ngModel)]="selectedRadioButton"
                (click)="getQuoteOnChange('Emailed')" />
              <span class="link">Emailed</span>
            </label>
            <label class="ms-2 nav-link p-0 d-flex align-items-center">
              <p-radioButton
                [value]="'Accepted'"
                id="Accepted"
                type="radio"
                class="me-2"
                name="radio"
                value="Openorder"
                [(ngModel)]="selectedRadioButton"
                (click)="getQuoteOnChange('Accepted')" />
              <span class="link">Accepted</span>
            </label>
            <label class="ms-2 nav-link p-0 d-flex align-items-center">
              <p-radioButton
                [value]="'Templete'"
                id="Templete"
                type="radio"
                class="me-2"
                name="radio"
                value="Openorder"
                [(ngModel)]="selectedRadioButton"
                (click)="getQuoteOnChange('Templete')" />
              <span class="link">Template</span>
            </label>
            <label class="ms-2 nav-link p-0 d-flex align-items-center">
              <p-radioButton
                [value]="'All'"
                id="All"
                type="radio"
                class="me-2"
                name="radio"
                [ariaChecked]="true"
                [(ngModel)]="selectedRadioButton"
                value="Openorder"
                (click)="getQuoteOnChange('All')" />
              <span class="link">All</span>
            </label>
          </div>
        </span>

        <span class="col-auto d-flex gap-3">
          <div
            class="orders-panel col-auto gap-2 d-flex justify-content-between">
            <p-button
              label="Export Excel"
              variant="outlined"
              icon="pi pi-cloud-upload"
              severity="secondary"
              (click)="exportExcel()"
              class="fullwdth secondary-btn" />

            <p-button
              label="Add New Proposal"
              (click)="onOrdersRedirection()"
              class="fullwdth secondary-btn" />
          </div>
        </span>
      </span>

      <div class="col-12">
        <p-table
          #dt
          stripedRows
          [rowHover]="true"
          [showCurrentPageReport]="true"
          [scrollable]="true"
          scrollHeight="calc(100vh - 310px)"
          [size]="'small'"
          [value]="filterQuoteListings"
          [(selection)]="selectedorderListing"
          styleClass="p-datatable-customers ordersListing  search-more"
          [rowHover]="true"
          [rows]="50"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 1000]"
          [paginator]="true"
          [filterDelay]="0"
          selectionMode="multiple"
          (onRowSelect)="onQuoteSelection()"
          (onRowUnselect)="onQuoteSelection()"
          (onFilter)="onFilter($event)"
          styleClass="table-listing">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th></th>
              <th class="number">Number</th>
              <th class="status" pSortableColumn="salesOrderStatusD365">
                Status
                <p-sortIcon field="salesOrderStatusD365"></p-sortIcon>
              </th>
              <th class="name">Client Name</th>
              <th class="jname">Job Name</th>
              <th class="jname">Billing Comment</th>
              <th class="buyer" pSortableColumn="buyerD365">
                Buyer
                <p-sortIcon field="buyerD365"></p-sortIcon>
              </th>
              <th class="cust-po" pSortableColumn="customerPONumberD365">
                Cust PO #
                <p-sortIcon field="customerPONumberD365"></p-sortIcon>
              </th>
              <th class="bconsultant">Branding Consultant</th>
              <th class="date-time" pSortableColumn="createdDate">
                Created Date & Time
                <p-sortIcon field="createdDate"></p-sortIcon>
              </th>
              <th class="subtotal">Order Subtotal</th>
              <th class="commission">Commission</th>
              <th class="gp" pSortableColumn="grossProfitD365">
                Gp% <p-sortIcon field="grossProfitD365"></p-sortIcon>
              </th>
              <th class="currency">Currency</th>
              <th class="inhanddate" pSortableColumn="inHandsDateD365">
                In Hands
                <p-sortIcon field="inHandsDateD365"></p-sortIcon>
              </th>
            </tr>
            <tr>
              <th></th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="salesOrderIdD365"
                    id="salesOrderIdD365"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'salesOrderIdD365',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="salesOrderStatusD365"
                    id="salesOrderStatusD365"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'salesOrderStatusD365',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="organizationNameD365"
                    id="organizationNameD365"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'organizationNameD365',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="jobNameD365"
                    id="jobNameD365"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'jobNameD365',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th></th>
              <th></th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="customerPONumberD365"
                    id="customerPONumberD365"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'customerPONumberD365',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="brandingConsultant"
                    id="brandingConsultant"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'brandingConsultant',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <jni-date-filter
                  [dataList]="quoteListings"
                  [columnName]="createdDateColumn"
                  (emitCancelFilter)="clearFilter($event)"
                  (emitApplyFilter)="applyFilter($event)"></jni-date-filter>
              </th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th>
                <jni-date-filter
                  [dataList]="quoteListings"
                  [columnName]="inHandDateColumn"
                  (emitCancelFilter)="clearFilter($event)"
                  (emitApplyFilter)="applyFilter($event)"></jni-date-filter>
              </th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-quoteListing
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row"
              [pSelectableRow]="quoteListing"
              [pSelectableRowIndex]="rowIndex">
              <td class="col-center">
                <p-tableCheckbox
                  class=""
                  [value]="quoteListing"
                  [pSelectableRow]="quoteListing"></p-tableCheckbox>
              </td>
              <td class="number">
                <a
                  class="link"
                  (click)="redirectToSummary(quoteListing.salesOrderIdD365)">
                  {{ quoteListing.salesOrderIdD365 }}</a
                >
              </td>
              <td class="status">{{ quoteListing.salesOrderStatusD365 }}</td>
              <td class="name">{{ quoteListing.organizationNameD365 }}</td>
              <td class="jname">{{ quoteListing.jobNameD365 }}</td>
              <td
                class="subtotal"
                (mouseenter)="
                  onHoverBillingComments(
                    quoteListing?.salesOrderIdD365,
                    quoteListing?.comment
                  );
                  billCommentPopover.toggle($event, targetPopover)
                ">
                <div
                  class="has-dropdown d-flex align-items-center"
                  #targetPopover>
                  <a [title]="quoteListing?.comment" class="link">
                    {{ quoteListing?.comment }}
                  </a>
                </div>
                <p-popover #billCommentPopover>
                  <jni-invoice-preview-billing-comment
                    *ngIf="orderNotesGridListing.length > 0"
                    [orderNotesGridListing]="orderNotesGridListing"
                    [orderNumber]="quoteListing?.salesOrderIdD365"
                    [orderBillingHeading]="'Comments'"
                    allComments="All Quote Notes"
                    class="ratings-box overall ms-2"
                    (orderNotesDisplayModalEvent)="
                      orderNotesDisplayModalFunction($event)
                    ">
                  </jni-invoice-preview-billing-comment>
                </p-popover>
              </td>
              <td class="buyer">{{ quoteListing.buyerD365 }}</td>
              <td class="cust-po">{{ quoteListing.customerPONumberD365 }}</td>
              <td class="bconsultant">
                {{ quoteListing.brandingConsultant }}
              </td>
              <td class="date-time">
                <span *ngIf="quoteListing?.createdDate | hidedynamicsdate">
                  {{ quoteListing.createdDate | date: "MM-dd-yyyy" }}
                </span>
              </td>
              <td class="subtotal">
                {{
                  quoteListing.orderSubTotal
                    | currency
                      : quoteListing.foreignCurrencyD365
                      : "symbol"
                      : "0.2-2"
                }}
              </td>
              <td class="commission">
                {{ quoteListing.commissionD365 | currency }}
              </td>
              <td class="gp">
                {{ quoteListing.grossProfitD365 | number: "1.2-2" }}
              </td>
              <td class="currency">
                {{ quoteListing.foreignCurrencyD365 }}
              </td>
              <td class="inhandate">
                {{ quoteListing.inHandsDateD365 | date: "MM-dd-yyyy" }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No quotes found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>

<jni-modal-stacker
  *ngIf="quoteDisplayModal"
  [displayModal]="quoteDisplayModal"
  (closeEvent)="closeModalForQuote()"
  class="modal-header-sticky">
  <h1 class="panelHeading">Proposal Summary</h1>
  <div class="panelBody">
    <jni-quote-summary
      [isModal]="true"
      [saleOrderIdFromModal]="saleOrderId"
      (closeModalEvent)="closeModalForQuote()"></jni-quote-summary>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="orderNotesDisplayModal"
  [displayModal]="orderNotesDisplayModal"
  (closeEvent)="closeModalForOrderNotes()">
  <h1 class="panelHeading">Order Notes</h1>
  <div class="panelBody">
    <jni-quote-notes-grid
      [orderNotesGridListing]="orderNotesGridListing"
      (closeModalEvent)="closeModalForOrderNotes()"></jni-quote-notes-grid>
  </div>
</jni-modal-stacker>
